// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"remove-button-module__removeButton--JjVRB"};